import * as types from "../../mutation-types";

export default {
    [types.FETCH_CURL_STATUS_SUCCESS] (state, { data }) {
        state.curl = data
    },

    [types.FETCH_CURL_STATUS_FAILURE] (state) {
        state.curl = null
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/curl/mutations.js